import {
  getCompanyEmployees,
  getCourtCases,
  getNeighbors,
  getDomainCerts,
  getCrypto,
  getSanctions,
  getReports,
  getDomainInfo,
  getBols,
  getMld,
} from "../../../api/wiki";
import bolpng from "../../../assets/images/wiki/bol.png";
import employeepng from "../../../assets/images/wiki/employee.png";
import courtpng from "../../../assets/images/wiki/court.png";
import sanctionpng from "../../../assets/images/wiki/sanction.png";
import govpng from "../../../assets/images/wiki/gov.png";
import cryptopng from "../../../assets/images/wiki/crypto.png";
import domainpng from "../../../assets/images/wiki/domain.png";
import neigborpng from "../../../assets/images/wiki/neighbor.png";
import reportspng from "../../../assets/images/wiki/reports.png";
import mldpng from "../../../assets/images/wiki/mld.png";
import TileEmployee from "./tiles/TileEmployee";
import TileCourtCase from "./tiles/TileCourtCase";
import TileNeighbor from "./tiles/TileNeighbor";
import TileDomain from "./tiles/TileDomain";
import TileCrypto from "./tiles/TileCrypto";
import TileSanction from "./tiles/TileSanction";
import TileReport from "./tiles/TileReport";
import TileDomainIP from "./tiles/TileDomainIP";
import TileBOLs from "./tiles/TileBOLs";
import TileMLD from "./tiles/TileMLD";

export const SYMBOL_MAP = {
  Polygon: "matic",
  Arbitrum: "arbi",
  Dogecoin: "doge",
  Bitcoin: "btc",
  Ethereum: "eth",
  Solana: "sol",
  "USD Coin": "usdc",
  Tether: "usdt",
};

export const SECTION_CONFIG = [
  { key: "Court Cases", image: courtpng, color: "#907b66", valueKey: "count" },
  { key: "BOLs", image: bolpng, color: "#7495a7", valueKey: null },
  {
    key: "Key Employees",
    image: employeepng,
    color: "#f27b07",
    valueKey: "length",
  },
  { key: "Neighbors", image: neigborpng, color: "#021317", valueKey: "length" },
  { key: "Sanctions", image: sanctionpng, color: "#9f260d", valueKey: "count" },
  { key: "Domains", image: domainpng, color: "#071d30", valueKey: "items" },
  { key: "Gov Awards", image: govpng, color: "#065e00", valueKey: null },
  { key: "Crypto", image: cryptopng, color: "#1f334a", valueKey: "length" },
  { key: "Reports", image: reportspng, color: "#262626", valueKey: "count" },
  // { key: "IPs", image: reportspng, color: "#262626", valueKey: "count" },
];

const str = (v) => (typeof v === "string" ? v.trim() : "");
const toStr = (v) =>
  typeof v === "string" ? v.trim() : typeof v === "number" ? String(v) : "";

export const TILE_CONFIG = {
  BOLs: {
    fetcher: getBols,
    Component: TileBOLs,
    image: bolpng,
    color: "#ff9f94",
    canRender: (d) => !!d.vessel_name,
  },
  MLD: {
    fetcher: getMld,
    Component: TileMLD,
    image: mldpng,
    color: "#376894",
    canRender: (d) => !!d.ip_address,
  },
  "Key Employees": {
    fetcher: getCompanyEmployees,
    Component: TileEmployee,
    image: employeepng,
    color: "#f27b07",
    singleColumn: true,
    canRender: (d) => {
      console.log(d);
      // const p = d?.json_response?.profile;
      // if (!p) return false;
      return true;
      // return !!(
      //   p.full_name ||
      //   p.first_name ||
      //   p.last_name ||
      //   p.headline ||
      //   p.occupation ||
      //   (Array.isArray(p.experiences) && p.experiences.length > 0)
      // );
    },
  },
  "Court Cases": {
    fetcher: getCourtCases,
    Component: TileCourtCase,
    image: courtpng,
    color: "#907b66",
    canRender: (d) =>
      !!(
        str(d.case_name) ||
        str(d.content) ||
        str(d.date_filed) ||
        str(d.docket_number)
      ),
  },
  Neighbors: {
    fetcher: getNeighbors,
    Component: TileNeighbor,
    image: neigborpng,
    color: "#021317",
    canRender: (d) => !!(toStr(d.neighbor) || toStr(d.url) || toStr(d.address)),
  },
  Domains: {
    fetcher: getDomainCerts,
    Component: TileDomain,
    image: domainpng,
    color: "#071d30",
    canRender: (d) =>
      !!(
        toStr(d.url) ||
        toStr(d.cert_id) ||
        toStr(d.common_name) ||
        toStr(d.issuer_ca_id) ||
        toStr(d.issuer_name) ||
        toStr(d.name_value) ||
        toStr(d.serial_number)
      ),
  },
  // IPs: {
  //   fetcher: getDomainInfo,
  //   Component: TileDomainIP,
  //   image: ippng,
  //   color: "#1f334a",
  //   canRender: (d) => !!toStr(d.ip_address),
  // },
  Sanctions: {
    fetcher: getSanctions,
    Component: TileSanction,
    image: sanctionpng,
    color: "#9f260d",
    canRender: (d) => !!toStr(d.sanctions_title),
  },
  // Crypto: {
  //   fetcher: getCrypto,
  //   Component: TileCrypto,
  //   image: cryptopng,
  //   color: "#1f334a",
  //   canRender: (d) => !!(str(d.coin) || str(d.title) || str(d.address)),
  // },
  Reports: {
    fetcher: getReports,
    Component: TileReport,
    image: reportspng,
    color: "#262626",
    canRender: (d) => !!(str(d.target_type) || str(d.content)),
    noActionWrapper: true,
  },
  // 'Mobile Data': {
  //   fetcher: get
  // }
};

export const GRID_SECTIONS = [
  "Key Employees",
  "Court Cases",
  "Neighbors",
  "Domains",
  "Sanctions",
  "Gov Awards",
  "BOLs",
  "Crypto",
  "Reports",
  "IPs",
  "MLD",
];
